import { Vue, prop } from 'vue-class-component';
import { WidgetWrapper } from '@/components/widget-wrapper';
import '@/styles/slider.scss';
import { Inject } from 'vue-property-decorator';
import type { VueI18n } from 'vue-i18n';
import { Button, ButtonTypes } from '@/components/button';
import { Routes } from '@/router/routes';
import { Icon, IconNames } from '@/components/icon';
import { getCookie } from '@/common';
import { WriteupModuleContext } from '@/store/writeup';
import { TealiumLink, TealiumPage } from '@/types/tealium-events';
import styles from './styles.module.scss';

class DealerDiscountProps {
	loading = prop<boolean>({ default: true })

	discountValue = prop<number>({ default: 0 })

	title = prop<string>({ default: '' })
}

export class DealerDiscount extends Vue.with(DealerDiscountProps) {
	@Inject() readonly i18n!: VueI18n;

	@Inject() readonly writeupModule!: WriteupModuleContext;

	get writeupId() { return this.writeupModule.getters.writeupObject?.writeupId; }

	get showUnlockedDiscount() {
		return this.discountValue < 0;
	}

	get checkCustomerDetails() {
		return !!getCookie('dealerDiscountUser');
	}

	get showDiscount() {
		return this.showUnlockedDiscount || this.checkCustomerDetails;
	}

	triggerTealium() {
		this.writeupModule.actions.updateTealiumDataLayer(
			{
				pageMapping: TealiumPage.CustomizeDeal,
				linkMapping: TealiumLink.Rebate,
			}
		);
	}

	render() {
		const lockIcon = {
			icon: () => <div>
				<Icon name={ IconNames.lock } size={ 18 } color='#aaaaaa'/>
			</div>,
		};

		return (
			<WidgetWrapper
				class={styles.dealerDiscount}
				title={this.title}
				active={ this.showUnlockedDiscount && this.checkCustomerDetails }
				v-slots={ !this.showUnlockedDiscount ? lockIcon : '' }
			>
				{!this.checkCustomerDetails
				&& <div>
					<div class={styles.dealerDiscountContent}>{this.i18n.t('dealerDiscount.content')}</div>
					<Button
						fullWidth
						type={ ButtonTypes.primary }
						inverted={ true }
						to={ Routes.DEALER_DISCOUNT_FORM }
						onClick={ this.triggerTealium }>{this.i18n.t('dealerDiscount.unlockDiscountButton')}
					</Button>
				</div>}
				{ this.showDiscount && this.checkCustomerDetails && <div class={styles.dealerDiscountValue}>{ this.i18n.n(this.discountValue, 'currency') }</div> }
			</WidgetWrapper>
		);
	}
}
